import {
    Model
} from '@/lib/BaseModel';
import fieldSpec from '@/models/commonFieldsSchema';


var UploadPreferencesSchema = {

    dogName: {
        label: fieldSpec.dogName.label,
        truncate: fieldSpec.dogName.maxLength,
    },

    // Internal breed code, e.g. bordercollie
    // NOTE: See note below on 'breedDesc' re: when breedId is 'mixed'
    breedId: {
        label: 'Breed',
        truncate: 50,
    },


    // Breed description
    // This is a MANDATORY field on the client front-end when breedId = 'mixed', i.e. user 
    // must enter short description to describe the breed, e.g. 'collie/shepherd cross'
    breedDesc: {
        label: fieldSpec.breedDesc.label,
        truncate: fieldSpec.breedDesc.maxLength,
    },


    // ************************ Make sure truncate values match maxLength attr in form field html ... and that 
    // 'size' in Firebase security rules is consistent too.

    fName: {
        label: fieldSpec.fName.label,
        truncate: fieldSpec.fName.maxLength,
    },

    lName: {
        label: fieldSpec.lName.label,
        truncate: fieldSpec.lName.maxLength,
    },

    city: {
        label: fieldSpec.city.label,
        truncate: fieldSpec.city.maxLength,

    },

    state: {
        label: 'State',
        truncate: 2,
    },

    province: {
        label: fieldSpec.province.label,
        truncate: fieldSpec.province.maxLength,
    },

    // 2-character country abbreviation
    country: {
        label: 'Country',
        truncate: 2,

    },

    captionLastName: {
        label: 'Caption Last Name Option',
        default: 'full' // two poss values: full, initial
    },


}

var UploadPreferences = Model.make('UploadPreferences', UploadPreferencesSchema);

export {
    UploadPreferences
};